<template>
    <div>
        <div class="systemTask-title">{{ $t('configuration_management.system_task.configureSystemTask') }}</div>
        <div class="systemTask-top">
            <system-task-search></system-task-search>
        </div>
        <table-system-task></table-system-task>
    </div>
</template>

<script>
    import SystemTaskSearch from '../system_task/SystemTaskSearch'
    import TableSystemTask from '../system_task/TableSystemTask'

    export default {
        name: 'SystemTask',
        components: {
            SystemTaskSearch,
            TableSystemTask
        }
    }
</script>

<style scoped>
    .systemTask-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .systemTask-top
    {
        width: 100%;
        height: 53px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/system_task/SystemTask.vue